import React, { useState, useCallback, useEffect } from 'react';
import HtmlParser from 'react-html-parser'
import { DivTimer, Timer } from "./styled";
const Tempo = () => {

  useEffect(() => {
    setInterval(time, 1000);
  }, []);

  const zero = (x) => {
    if (x < 10) {
      x = '0' + x;
    } return x;
  }
  const time = () => {

    let localTime = new Date();
    let hora = localTime.getHours();
    let minuto = localTime.getMinutes();
    let segundo = localTime.getSeconds();
    minuto = zero(minuto);
    segundo = zero(segundo);
    document.getElementById('hora').textContent = hora + ':' + minuto + ':' + segundo;
  }

  return (
    <>
      <Timer id="hora"></Timer>
    </>
  );
}

export default Tempo;